import { IApplicationState } from '../../types/redux';
import { IOfferForAnalytic } from '../../utils/tracking/types';

export const selectSubmittedAnketaModalOffer = (state: IApplicationState): IOfferForAnalytic | null =>
  state.calculator.submittedAnketaModal.offerForAnalytic;
